<template>
    <div class="compare-coverage">
        <div class="placeholder">
            <div class="placeholder__heading">
                DB
            </div>
            <div class="placeholder padding">
                <vue-apex-charts
                    ref="tester"
                    :height="height"
                    :options="options"
                    :series="series"
                    v-if="!loading && series.length > 0"
                    type="line"
                />

                <box-loading height="400" v-else />
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: value => {
                            // if (value > 0) {
                                return this.$options.filters.currency(value)
                            // }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    /* showForSingleSeries: false,
                    showForNullSeries: false,
                    showForZeroSeries: false, */
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        }
    },
    components: {
        VueApexCharts
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.series = []
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            /* if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            } */
            economyService.compareCoverage(params, (response) => {
                this.options.labels = response.data.labels
                this.series = response.data.series
                // this.series = response.data.values
                this.loading = false
                this.$emit('finishedLoading', response.data.series.length)
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            // let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// compareCoverage.vue?05c5d535